// React.

// Material UI
import Paper from "@material-ui/core/Paper"
import Typography from "@material-ui/core/Typography"

// Translations.
import { useTranslation } from "react-i18next"

// Styles.
import { Box, Chip, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core"
import useStyles from "./BulkItemQueueTitleStyles"

interface BulkItemQueueTitleProps {
  statusSelected: string[]
  setStatusSelected: React.Dispatch<React.SetStateAction<string[]>>
}

const BulkItemQueueTitle = ({
  statusSelected,
  setStatusSelected,
}: BulkItemQueueTitleProps) => {
  const classes = useStyles()
  const [t] = useTranslation("global")

  const values = ["Error", "Completado", "En proceso", "Programado","Cancelado"]

  const handleChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    // Actualiza el estado con las opciones seleccionadas
    setStatusSelected(e.target.value as string[])
  }
  return (
    <div className={classes.root}>
      <Paper elevation={3}>
        <div className={classes.boxTop}>
          <Typography variant="h5" color="primary">
            {t("nav.bulk-items-queue")}
          </Typography>
          <div className={classes.selectWrapper}>
            <FormControl style={{ width: "400px" }}>
              <InputLabel id="items-select-status">
                {t("items.select-status")}
              </InputLabel>
              <Select
                labelId="items-select-status"
                multiple // Habilitar selección múltiple
                value={statusSelected}
                onChange={handleChange}
                displayEmpty
                renderValue={(selected: unknown) => {
                  // Si no hay selección, muestra el texto por defecto
                  if ((selected as string[]).length === 0) {
                    return <em>{t("items.select-status")}</em>
                  }
                  return (
                    <Box display="flex" flexWrap="wrap">
                      {(selected as string[]).map((value) => (
                        <Chip key={value} label={value} style={{ margin: 2 }} />
                      ))}
                    </Box>
                  )
                }}
              >
                {values.map((status: string, index: number) => (
                  <MenuItem key={index} value={status}>
                    {status}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      </Paper>
    </div>
  )
}

export default BulkItemQueueTitle
